document.addEventListener("DOMContentLoaded", function() {

	const $ = jQuery.noConflict();
    
    // Tabs
	const id = $('.section__tabs--content').attr('id');
	$('.section__tabs ul.nav li').removeClass('active');
	$('.section__tabs ul.nav li').each(function() {
		i++;
		$(this).addClass('tab-id-' + i);
		$(this).children('a').attr('data-tab','#tab-id-' + i);
		const cl = $(this).attr('class');		
		if ( $(this).hasClass(id) ) {
			$(this).addClass('active');
			//console.log(id);
		}
	});

	/**
	 * ACF Blocks TABS
	 */
	const tabs = document.querySelectorAll("[data-tab-target]");
	const tabContents = document.querySelectorAll("[data-tab-content]");

	$(tabs).each(function(i, tab){
		
		$(tab).on('click', function(){

			const target = $(this).attr("data-tab-target");

			$(tabContents).each(function(i, tabContent) {
				$(tabContent).removeClass('active');
			});

			$(tabs).each(function(i, tab){
				$(tab).removeClass('active');
			});

			$(tab).addClass('active');
			$(target).addClass('active');

			$(tabContents).each(function(tabContent){
				const targetContent = $(this).attr("data-tab-content");

				if (targetContent == target) {
					let activeContent = document.getElementById(target);
					$(activeContent).addClass('active');
				}
			});
		});
	});
});